export interface paths {
  '/admin/analytics/overview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminAnalyticsControllerGetPlatformAnalytics'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessControllerFindAll'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessControllerFindById'];
    put: operations['adminBusinessControllerUpdate'];
    post?: never;
    delete: operations['adminBusinessControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['adminBusinessControllerUpdateStatus'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}/reviews': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessControllerGetReviews'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}/reviews/{reviewId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['adminBusinessControllerToggleReview'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/businesses/{id}/reviews/{reviewId}/score-inclusion': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['adminBusinessControllerToggleReviewScoreInclusion'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/status': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessImportControllerGetStatus'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/parse': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminBusinessImportControllerParseImportFile'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/fetch-details': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminBusinessImportControllerFetchPlaceDetails'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/businesses': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminBusinessImportControllerImportBusinesses'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/businesses/{id}/refresh-preview': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminBusinessImportControllerGetRefreshPreview'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/businesses/{id}/refresh': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminBusinessImportControllerApplyRefreshChanges'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/categories': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminCategoryControllerFindAll'];
    put?: never;
    post: operations['adminCategoryControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/categories/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminCategoryControllerFindById'];
    put: operations['adminCategoryControllerUpdate'];
    post?: never;
    delete: operations['adminCategoryControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/filters': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminFilterControllerFindAll'];
    put?: never;
    post: operations['adminFilterControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/filters/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminFilterControllerFindById'];
    put: operations['adminFilterControllerUpdate'];
    post?: never;
    delete: operations['adminFilterControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/providers': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminImportJobControllerGetProviders'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminImportJobControllerListJobs'];
    put?: never;
    post: operations['adminImportJobControllerCreateJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminImportJobControllerGetJobProgress'];
    put?: never;
    post?: never;
    delete: operations['adminImportJobControllerDeleteJob'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/items': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminImportJobControllerGetJobItems'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/pause': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminImportJobControllerPauseJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/resume': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminImportJobControllerResumeJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/retry': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminImportJobControllerRetryFailedItems'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/import/jobs/{id}/cancel': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['adminImportJobControllerCancelJob'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{userId}/plans': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminPlanControllerFindAllByUser'];
    put?: never;
    post: operations['adminPlanControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{userId}/plans/{planId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminPlanControllerFindById'];
    put: operations['adminPlanControllerUpdate'];
    post?: never;
    delete: operations['adminPlanControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/scores/recalculate-all': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Queue score recalculation for all active businesses
     * @description Queues a background job to recalculate work-friendly scores for all active businesses. This is typically run weekly but can be triggered manually.
     */
    post: operations['adminScoresControllerRecalculateAllScores'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/scores/recalculate/{businessId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Immediately recalculate score for a single business
     * @description Synchronously recalculates the work-friendly score for a specific business. Use this for testing or when you need immediate results.
     */
    post: operations['adminScoresControllerRecalculateSingleScore'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminUsersControllerFindAll'];
    put?: never;
    post: operations['adminUsersControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/me': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminUsersControllerGetMe'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminUsersControllerFindById'];
    put: operations['adminUsersControllerUpdate'];
    post?: never;
    delete: operations['adminUsersControllerDelete'];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{id}/role': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put: operations['adminUsersControllerUpdateRole'];
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/admin/users/{id}/abilities': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['adminUsersControllerGetUserAbilities'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['businessControllerCreateBusiness'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/findNearby': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessControllerFindNearby'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/findWithinArea': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessControllerFindWithinArea'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/findByName': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessControllerFindByName'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/checkByProvider': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessControllerCheckBusinessByProvider'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/{businessId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessIdControllerFindById'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/business/{businessId}/reviews': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['businessReviewsControllerFindReviews'];
    put?: never;
    post: operations['businessReviewsControllerCreateReview'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/category': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['categoryControllerGetAll'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/config/ping': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['configControllerHealthCheck'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/config/version': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['configControllerGetAppVersion'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/favorite': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['favoriteControllerGetFavorites'];
    put?: never;
    post: operations['favoriteControllerSetFavoriteStatus'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/filter': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['filterControllerGetAll'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/img/{id}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get display image (most common use)
     * @description Returns the display-sized image URL (800px, WebP)
     */
    get: operations['imageControllerGetDisplayImage'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/img/{id}/thumb': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get thumbnail image
     * @description Returns the thumbnail-sized image URL (200px, WebP)
     */
    get: operations['imageControllerGetThumbnail'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/img/{id}/original': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get original image
     * @description Returns the original-sized image URL (1600px, WebP)
     */
    get: operations['imageControllerGetOriginal'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/img/{id}/size': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * Get image by size preference
     * @description Returns image based on width requirement
     */
    get: operations['imageControllerGetBySize'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/plan': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['planControllerGetByUser'];
    put?: never;
    post: operations['planControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/plan/{planId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete: operations['planControllerDeletePlan'];
    options?: never;
    head?: never;
    patch: operations['planControllerUpdatePlan'];
    trace?: never;
  };
  '/user': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['userControllerFindById'];
    put: operations['userControllerUpdateUser'];
    post: operations['userControllerCreate'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user/push-token': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['userControllerSavePushToken'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/user-events': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post: operations['userEventControllerTrackEvent'];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/.well-known/apple-app-site-association': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['webControllerAppleAppSiteAssociation'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/.well-known/assetlinks.json': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['webControllerDigitalAssetLinks'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  '/b/{businessId}': {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get: operations['webControllerBusinessWebFallback'];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    Business: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      name: string;
      address: string;
      postalCode: string;
      city: string;
      province?: string;
      country: string;
      /** Format: url */
      website?: string;
      phone?: string;
      location?: components['schemas']['GeographyPoint'];
      /** @enum {string} */
      status?: BusinessStatus;
      workFriendlyScore?: number;
      approvedReviewCount?: number;
      scoreConfidence?: number;
      scoreCalculatedAt?: string;
      distance?: number;
      images?: components['schemas']['BusinessImage'][];
      openingHours?: components['schemas']['BusinessOpeningHour'][];
      filters?: components['schemas']['BusinessFilter'][];
      businessCategories?: components['schemas']['BusinessCategory'][];
      reviews?: components['schemas']['BusinessReview'][];
      isFavorite?: boolean;
    };
    GeographyPoint: {
      type: string;
      coordinates: number[];
    };
    BusinessImage: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      image?: components['schemas']['Image'];
      primary: boolean;
    };
    Image: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      /** Format: url */
      primaryUrl: string;
      variants?: unknown[];
    };
    BusinessOpeningHour: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      /** @enum {number} */
      dayOfWeek: BusinessOpeningHourDayOfWeek;
      openTime: string;
      closeTime: string;
    };
    BusinessFilter: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      filter: components['schemas']['Filter'];
      /** @enum {string} */
      level: BusinessFilterLevel;
    };
    Filter: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      name: string;
      enabled?: boolean;
      isMandatory?: boolean;
      /** @enum {string} */
      importance?: FilterImportance;
      /** @enum {string} */
      notAvailableImpact?: FilterNotAvailableImpact;
      businessCount?: number;
    };
    BusinessCategory: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      category: Record<string, never>;
    };
    BusinessReview: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      user?: Record<string, never>;
      review?: string;
      filters?: components['schemas']['BusinessReviewFilter'][];
      isIncludedInAverage?: boolean;
      isEvaluated?: boolean;
    };
    BusinessReviewFilter: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      filter: components['schemas']['Filter'];
      /** @enum {string} */
      level?: BusinessReviewFilterLevel;
    };
    NotFound: {
      /**
       * @description The error name
       * @default NOT_FOUND
       * @example NOT_FOUND
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 404
       * @example 404
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    GenericError: {
      /** @description The error name */
      name: string;
      /** @description An error message */
      message: string;
    } & {
      [key: string]: unknown;
    };
    AdminBusinessUpdateDTO: {
      name?: string;
      address?: string;
      postalCode?: string;
      city?: string;
      province?: string;
      country?: string;
      /** Format: url */
      website?: string;
      phone?: string;
      /** @enum {string} */
      status?: AdminBusinessUpdateDTOStatus;
      categoryIds?: number[];
      filterIds?: number[];
      openingHours?: components['schemas']['AdminOpeningHourDTO'][];
    };
    AdminOpeningHourDTO: {
      id?: number;
      /** @enum {number} */
      dayOfWeek?: AdminOpeningHourDTODayOfWeek;
      openTime?: string;
      closeTime?: string;
    };
    AdminBusinessStatusUpdateDTO: {
      /** @enum {string} */
      status?: AdminBusinessStatusUpdateDTOStatus;
    };
    AdminReviewToggleDTO: {
      isEvaluated?: boolean;
    };
    AdminReviewScoreInclusionDTO: {
      isIncludedInAverage?: boolean;
    };
    MapProviderStatusDTO: {
      configured: boolean;
      message?: string;
      provider: components['schemas']['MapProviderInfoDTO'];
    };
    MapProviderInfoDTO: {
      /** @enum {string} */
      identifier: MapProviderInfoDTOIdentifier;
      name: string;
    };
    ImportPreviewItemDTO: {
      placeId: string;
      title?: string;
      url?: string;
      /** @enum {string} */
      status: ImportPreviewItemDTOStatus;
      existingBusinessId?: number;
      existingBusinessName?: string;
      error?: string;
    };
    ParseImportFileDTO: {
      content: string;
      /** @enum {string} */
      format: ParseImportFileDTOFormat;
    };
    FetchPlaceDetailsDTO: {
      placeIds: string[];
    };
    BulkImportProgressDTO: {
      total: number;
      processed: number;
      successful: number;
      failed: number;
      skipped: number;
      results?: components['schemas']['ImportResultDTO'][];
    };
    ImportResultDTO: {
      success: boolean;
      businessId?: number;
      businessName?: string;
      placeId: string;
      error?: string;
    };
    ImportBusinessesDTO: {
      placeIds: string[];
      categoryIds?: number[];
      filterIds?: number[];
      /**
       * @default Pending
       * @enum {string}
       */
      status: ImportBusinessesDTOStatus;
      /** @default true */
      skipExisting: boolean;
    };
    RefreshComparisonDTO: {
      hasChanges: boolean;
      nameChange?: components['schemas']['RefreshChangeDTO'];
      addressChange?: components['schemas']['RefreshChangeDTO'];
      phoneChange?: components['schemas']['RefreshChangeDTO'];
      websiteChange?: components['schemas']['RefreshChangeDTO'];
      openingHoursChange?: components['schemas']['OpeningHoursChangeDTO'];
      newPhotosCount: number;
      newPhotos?: components['schemas']['SyncDataPhotoDTO'][];
      lastSyncedAt?: string;
      cachedResponse?: components['schemas']['CachedMapResponseDTO'];
      provider: components['schemas']['MapProviderInfoDTO'];
    };
    RefreshChangeDTO: {
      old?: Record<string, never>;
      new?: Record<string, never>;
    };
    OpeningHoursChangeDTO: {
      old?: unknown[];
      new?: unknown[];
    };
    SyncDataPhotoDTO: {
      widthPx: number;
      heightPx: number;
      authorName?: string;
      authorUri?: string;
    };
    CachedMapResponseDTO: {
      fetchedAt: string;
      /** @enum {string} */
      provider: CachedMapResponseDTOProvider;
      data: components['schemas']['MapProviderRawDataDTO'];
    };
    MapProviderRawDataDTO: {
      [key: string]: unknown;
    };
    ApplyRefreshChangesDTO: {
      /** @default false */
      applyName: boolean;
      /** @default false */
      applyAddress: boolean;
      /** @default false */
      applyPhone: boolean;
      /** @default false */
      applyWebsite: boolean;
      /** @default false */
      applyOpeningHours: boolean;
      /** @default false */
      addNewPhotos: boolean;
      cachedResponse?: components['schemas']['CachedMapResponseDTO'];
    };
    Category: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      name: string;
      enabled?: boolean;
      businessCount?: number;
    };
    AdminCategoryCreateDTO: {
      name: string;
    };
    AdminCategoryUpdateDTO: {
      name?: string;
      enabled?: boolean;
    };
    AdminFilterCreateDTO: {
      name: string;
      /** @default false */
      isMandatory: boolean;
    };
    AdminFilterUpdateDTO: {
      name?: string;
      enabled?: boolean;
      isMandatory?: boolean;
    };
    ImportJobProgressDTO: {
      id: number;
      /** @enum {string} */
      status: ImportJobProgressDTOStatus;
      provider: string;
      totalItems: number;
      processedItems: number;
      successfulItems: number;
      failedItems: number;
      skippedItems: number;
      percentComplete: number;
      createdAt: string;
      updatedAt: string;
    };
    CreateImportJobDTO: {
      provider: string;
      externalIds?: string[];
      urls?: string[];
      categoryIds?: number[];
      filterIds?: number[];
      /** @default Pending */
      businessStatus: string;
    };
    ImportJobListDTO: {
      id: number;
      /** @enum {string} */
      status: ImportJobListDTOStatus;
      provider: string;
      totalItems: number;
      processedItems: number;
      successfulItems: number;
      failedItems: number;
      createdAt: string;
    };
    ImportJobItemDTO: {
      id: number;
      externalId: string;
      /** @enum {string} */
      status: ImportJobItemDTOStatus;
      businessId?: number;
      businessName?: string;
      error?: string;
      processedAt?: string;
    };
    Plan: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      user: components['schemas']['User'];
      business: components['schemas']['Business'];
      startAt: string;
      endAt: string;
      /** Format: date-time */
      checkInAt?: string;
      /** Format: date-time */
      checkOutAt?: string;
      /** @enum {number} */
      status?: PlanStatus;
    };
    User: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      /** Format: email */
      email: string;
      phone: string;
      firstName: string;
      lastName: string;
      authId: string;
      enabled?: boolean;
      disabledAt?: string;
      roles?: string[];
      customPermissions?: string[];
    };
    BadRequest: {
      /**
       * @description The error name
       * @default BAD_REQUEST
       * @example BAD_REQUEST
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 400
       * @example 400
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    AdminPlanCreateDTO: {
      businessId: number;
      /** Format: date-time */
      startAt: string;
      /** Format: date-time */
      endAt: string;
    };
    AdminPlanUpdateDTO: {
      /** @enum {number} */
      status?: AdminPlanUpdateDTOStatus;
      /** Format: date-time */
      checkInAt?: string;
      /** Format: date-time */
      checkOutAt?: string;
    };
    BatchRecalculationResponse: {
      queued?: number;
    };
    SingleRecalculationResponse: {
      businessId?: number;
      score?: number;
      reviewCount?: number;
      confidence?: number;
    };
    UserRoleUpdateDTO: {
      /** @enum {string} */
      role: UserRoleUpdateDTORole;
      subject?: string;
    };
    AdminUserCreateDTO: {
      /** Format: email */
      email: string;
      phone: string;
      password: string;
      firstName: string;
      lastName: string;
      /** @enum {string} */
      role: AdminUserCreateDTORole;
      subject?: string;
    };
    AdminUserUpdateDTO: {
      /** Format: email */
      email?: string;
      phone?: string;
      firstName: string;
      lastName: string;
      /** @enum {string} */
      role?: AdminUserUpdateDTORole;
      subject?: string;
      enabled?: boolean;
    };
    BusinessCreateDTO: {
      name: string;
      address: string;
      postalCode: string;
      city: string;
      province?: string;
      country: string;
      /** Format: url */
      website?: string;
      phone?: string;
      location: components['schemas']['GeographyPoint'];
      images: string[];
      primaryImageIndex: number;
      categoriesIds: number[];
      filterIds?: number[];
      openingHours: components['schemas']['BusinessCreateOpeningHourDTO'][];
      review?: components['schemas']['BusinessCreateReviewDTO'];
      mapProvider: components['schemas']['BusinessCreateMapProviderDTO'];
    };
    BusinessCreateOpeningHourDTO: {
      /** @enum {number} */
      dayOfWeek: BusinessCreateOpeningHourDTODayOfWeek;
      openTime: string;
      closeTime: string;
    };
    BusinessCreateReviewDTO: {
      text?: string;
      ratings: components['schemas']['BusinessCreateRatingDTO'][];
    };
    BusinessCreateRatingDTO: {
      filterId: number;
      /** @enum {string} */
      level: BusinessCreateRatingDTOLevel;
    };
    BusinessCreateMapProviderDTO: {
      providerId: string;
      externalId: string;
    };
    BusinessReviewCreateDTO: {
      review?: string;
      filters?: components['schemas']['BusinessReviewFilterCreateDTO'][];
    };
    BusinessReviewFilterCreateDTO: {
      filterId: number;
      /** @enum {string} */
      level: BusinessReviewFilterCreateDTOLevel;
    };
    InternalServerError: {
      /**
       * @description The error name
       * @default INTERNAL_SERVER_ERROR
       * @example INTERNAL_SERVER_ERROR
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 500
       * @example 500
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    VersionResponse: {
      needsUpdate: boolean;
      forceUpdate: boolean;
      updateMessage?: string;
      appStoreUrl?: string;
      latestVersion?: string;
      minimumVersion?: string;
    };
    Favorite: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      business: Record<string, never>;
    };
    FavoriteUpdateDTO: {
      businessId: number;
      isFavorite: boolean;
    };
    ImageResponse: {
      url: string;
      format: string;
      size: string;
      width: number;
      height: number;
    };
    Unauthorized: {
      /**
       * @description The error name
       * @default UNAUTHORIZED
       * @example UNAUTHORIZED
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 401
       * @example 401
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    PlanCreateDTO: {
      businessId: number;
      /** Format: date-time */
      startAt: string;
      /** Format: date-time */
      endAt: string;
    };
    PlanUpdateDTO: {
      /** @enum {number} */
      status?: PlanUpdateDTOStatus;
    };
    Conflict: {
      /**
       * @description The error name
       * @default CONFLICT
       * @example CONFLICT
       */
      name: string;
      /** @description An error message */
      message: string;
      /**
       * @description The status code of the exception
       * @default 409
       * @example 409
       */
      status: number;
      /** @description A list of related errors */
      errors?: components['schemas']['GenericError'][];
      /** @description The stack trace (only in development mode) */
      stack?: string;
    };
    UserCreateDTO: {
      /** Format: email */
      email: string;
      phone: string;
      password: string;
      firstName: string;
      lastName: string;
    };
    UserUpdateDTO: {
      /** Format: email */
      email?: string;
      phone?: string;
      firstName: string;
      lastName: string;
    };
    PushToken: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      userId: number;
      expoPushToken: string;
      deviceType?: string;
      isActive?: boolean;
    };
    PushTokenCreateDTO: {
      expoPushToken: string;
      deviceType?: string;
    };
    UserEvent: {
      id?: number;
      createdAt?: string;
      updatedAt?: string;
      deletedAt?: string;
      eventType?: string;
      /** @enum {string} */
      entityType?: UserEventEntityType;
      entityId?: number;
      properties?: Record<string, never>;
      /** @enum {string} */
      source?: UserEventSource;
    };
    UserEventCreateDTO: {
      /** @enum {string} */
      eventType: UserEventCreateDTOEventType;
      /** @enum {string} */
      entityType?: UserEventCreateDTOEntityType;
      entityId?: number;
      properties?: {
        [key: string]: unknown;
      };
      /** @enum {string} */
      source?: UserEventCreateDTOSource;
    };
  };
  responses: never;
  parameters: never;
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  adminAnalyticsControllerGetPlatformAnalytics: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': unknown;
        };
      };
    };
  };
  adminBusinessControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        search?: string;
        status?: PathsAdminBusinessesGetParametersQueryStatus;
        categoryId?: number;
        country?: string;
        sortBy?: string;
        sortOrder?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'][];
        };
      };
    };
  };
  adminBusinessControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminBusinessUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessControllerUpdateStatus: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminBusinessStatusUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessControllerGetReviews: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
      };
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'][];
        };
      };
    };
  };
  adminBusinessControllerToggleReview: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
        reviewId: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminReviewToggleDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessControllerToggleReviewScoreInclusion: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
        reviewId: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminReviewScoreInclusionDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessImportControllerGetStatus: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['MapProviderStatusDTO'];
        };
      };
    };
  };
  adminBusinessImportControllerParseImportFile: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['ParseImportFileDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportPreviewItemDTO'][];
        };
      };
    };
  };
  adminBusinessImportControllerFetchPlaceDetails: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FetchPlaceDetailsDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': Record<string, never>;
        };
      };
    };
  };
  adminBusinessImportControllerImportBusinesses: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['ImportBusinessesDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BulkImportProgressDTO'];
        };
      };
    };
  };
  adminBusinessImportControllerGetRefreshPreview: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['RefreshComparisonDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminBusinessImportControllerApplyRefreshChanges: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['ApplyRefreshChangesDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminCategoryControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        search?: string;
        enabled?: boolean;
        sortBy?: string;
        sortOrder?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'][];
        };
      };
    };
  };
  adminCategoryControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminCategoryCreateDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'];
        };
      };
    };
  };
  adminCategoryControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminCategoryControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminCategoryUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminCategoryControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminFilterControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        search?: string;
        enabled?: boolean;
        isMandatory?: boolean;
        sortBy?: string;
        sortOrder?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'][];
        };
      };
    };
  };
  adminFilterControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminFilterCreateDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'];
        };
      };
    };
  };
  adminFilterControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminFilterControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminFilterUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminFilterControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminImportJobControllerGetProviders: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': unknown[];
        };
      };
    };
  };
  adminImportJobControllerListJobs: {
    parameters: {
      query?: {
        limit?: number;
        offset?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobListDTO'][];
        };
      };
    };
  };
  adminImportJobControllerCreateJob: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['CreateImportJobDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminImportJobControllerGetJobProgress: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminImportJobControllerDeleteJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
    };
  };
  adminImportJobControllerGetJobItems: {
    parameters: {
      query?: {
        status?: string;
        limit?: number;
        offset?: number;
      };
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobItemDTO'][];
        };
      };
    };
  };
  adminImportJobControllerPauseJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminImportJobControllerResumeJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminImportJobControllerRetryFailedItems: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminImportJobControllerCancelJob: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImportJobProgressDTO'];
        };
      };
    };
  };
  adminPlanControllerFindAllByUser: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        status?: PathsAdminUsersUserIdPlansGetParametersQueryStatus;
        sortBy?: string;
        sortOrder?: string;
      };
      header?: never;
      path: {
        userId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'][];
        };
      };
    };
  };
  adminPlanControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        userId: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminPlanCreateDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminPlanControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        userId: number;
        planId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminPlanControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        userId: number;
        planId: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminPlanUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminPlanControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        userId: number;
        planId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminScoresControllerRecalculateAllScores: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BatchRecalculationResponse'];
        };
      };
    };
  };
  adminScoresControllerRecalculateSingleScore: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['SingleRecalculationResponse'];
        };
      };
    };
  };
  adminUsersControllerFindAll: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
        search?: string;
        role?: string;
        enabled?: boolean;
        sortBy?: string;
        sortOrder?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'][];
        };
      };
    };
  };
  adminUsersControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminUserCreateDTO'];
      };
    };
    responses: {
      /** @description Created */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  adminUsersControllerGetMe: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerUpdate: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['AdminUserUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerDelete: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description No Content */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerUpdateRole: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UserRoleUpdateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  adminUsersControllerGetUserAbilities: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': Record<string, never>;
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  businessControllerCreateBusiness: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['BusinessCreateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  businessControllerFindNearby: {
    parameters: {
      query: {
        longitude: number;
        latitude: number;
        userLongitude: number;
        userLatitude: number;
        searchText?: string;
        filterIds?: string;
        categoryIds?: string;
        page: number;
        limit: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'][];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  businessControllerFindWithinArea: {
    parameters: {
      query: {
        latitude: number;
        longitude: number;
        latitudeDelta: number;
        longitudeDelta: number;
        userLongitude: number;
        userLatitude: number;
        searchText?: string;
        filterIds?: string;
        categoryIds?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'][];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  businessControllerFindByName: {
    parameters: {
      query: {
        name: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  businessControllerCheckBusinessByProvider: {
    parameters: {
      query: {
        providerId: string;
        externalId: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': Record<string, never>;
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  businessIdControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Business'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  businessReviewsControllerFindReviews: {
    parameters: {
      query?: {
        page?: number;
        limit?: number;
      };
      header?: never;
      path: {
        businessId: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'][];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  businessReviewsControllerCreateReview: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: string;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['BusinessReviewCreateDTO'];
      };
    };
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BusinessReview'];
        };
      };
      /** @description Bad Request */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
    };
  };
  categoryControllerGetAll: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description List of business categories */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Category'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  configControllerHealthCheck: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Health check successful */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          '*/*': unknown;
        };
      };
    };
  };
  configControllerGetAppVersion: {
    parameters: {
      query?: {
        platform?: string;
        current_version?: string;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Version check completed */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['VersionResponse'];
        };
      };
      /** @description Invalid platform or version */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  favoriteControllerGetFavorites: {
    parameters: {
      query: {
        userLongitude: number;
        userLatitude: number;
        page: number;
        limit: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description User favorite businesses */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Favorite'][];
        };
      };
      /** @description Invalid coordinates or pagination */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  favoriteControllerSetFavoriteStatus: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['FavoriteUpdateDTO'];
      };
    };
    responses: {
      /** @description Favorite status updated */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Favorite'];
        };
      };
      /** @description Invalid request data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Business not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  filterControllerGetAll: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description List of business filters */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Filter'][];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  imageControllerGetDisplayImage: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImageResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  imageControllerGetThumbnail: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImageResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  imageControllerGetOriginal: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImageResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  imageControllerGetBySize: {
    parameters: {
      query?: {
        w?: number;
      };
      header?: never;
      path: {
        id: string;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['ImageResponse'];
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
  planControllerGetByUser: {
    parameters: {
      query: {
        page: number;
        limit: number;
        userLongitude?: number;
        userLatitude?: number;
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description User plans retrieved successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'][];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  planControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['PlanCreateDTO'];
      };
    };
    responses: {
      /** @description Plan created successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'];
        };
      };
      /** @description Invalid plan data or business not found */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  planControllerDeletePlan: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        planId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Plan deleted successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Not authorized to delete this plan */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Plan not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  planControllerUpdatePlan: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        planId: number;
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['PlanUpdateDTO'];
      };
    };
    responses: {
      /** @description Plan updated successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Plan'];
        };
      };
      /** @description Invalid update data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Not authorized to update this plan */
      403: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Unauthorized'];
        };
      };
      /** @description Plan not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerFindById: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Current user profile */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description User not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerUpdateUser: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UserUpdateDTO'];
      };
    };
    responses: {
      /** @description User updated successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Invalid user data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description User not found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerCreate: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UserCreateDTO'];
      };
    };
    responses: {
      /** @description User created successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['User'];
        };
      };
      /** @description Invalid user data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description User already exists */
      409: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['Conflict'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userControllerSavePushToken: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['PushTokenCreateDTO'];
      };
    };
    responses: {
      /** @description Push token saved successfully */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['PushToken'];
        };
      };
      /** @description Invalid push token data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Authentication required */
      401: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  userEventControllerTrackEvent: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: {
      content: {
        'application/json': components['schemas']['UserEventCreateDTO'];
      };
    };
    responses: {
      /** @description Event tracked successfully */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['UserEvent'];
        };
      };
      /** @description Invalid event data */
      400: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['BadRequest'];
        };
      };
      /** @description Internal Server Error */
      500: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['InternalServerError'];
        };
      };
    };
  };
  webControllerAppleAppSiteAssociation: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string;
        };
      };
    };
  };
  webControllerDigitalAssetLinks: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': string;
        };
      };
    };
  };
  webControllerBusinessWebFallback: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        businessId: number;
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Success */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'text/html': string;
        };
      };
      /** @description Not Found */
      404: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          'application/json': components['schemas']['NotFound'];
        };
      };
    };
  };
}
export enum PathsAdminBusinessesGetParametersQueryStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum PathsAdminUsersUserIdPlansGetParametersQueryStatus {
  Value0 = 0,
  Value1 = 1,
}
export enum BusinessStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum BusinessOpeningHourDayOfWeek {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}
export enum BusinessFilterLevel {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  NotAvailable = 'NotAvailable',
}
export enum FilterImportance {
  Critical = 'Critical',
  Important = 'Important',
  NiceToHave = 'NiceToHave',
}
export enum FilterNotAvailableImpact {
  negative = 'negative',
  neutral = 'neutral',
}
export enum BusinessReviewFilterLevel {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  NotAvailable = 'NotAvailable',
}
export enum AdminBusinessUpdateDTOStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum AdminOpeningHourDTODayOfWeek {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}
export enum AdminBusinessStatusUpdateDTOStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum MapProviderInfoDTOIdentifier {
  google_maps = 'google_maps',
}
export enum ImportPreviewItemDTOStatus {
  new = 'new',
  exists = 'exists',
  error = 'error',
}
export enum ParseImportFileDTOFormat {
  json = 'json',
  csv = 'csv',
}
export enum ImportBusinessesDTOStatus {
  Pending = 'Pending',
  Active = 'Active',
  Inactive = 'Inactive',
}
export enum CachedMapResponseDTOProvider {
  google_maps = 'google_maps',
}
export enum ImportJobProgressDTOStatus {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  paused = 'paused',
  cancelled = 'cancelled',
}
export enum ImportJobListDTOStatus {
  pending = 'pending',
  processing = 'processing',
  completed = 'completed',
  failed = 'failed',
  paused = 'paused',
  cancelled = 'cancelled',
}
export enum ImportJobItemDTOStatus {
  pending = 'pending',
  processing = 'processing',
  success = 'success',
  failed = 'failed',
  skipped = 'skipped',
}
export enum PlanStatus {
  Value0 = 0,
  Value1 = 1,
}
export enum AdminPlanUpdateDTOStatus {
  Value0 = 0,
  Value1 = 1,
}
export enum UserRoleUpdateDTORole {
  platform_admin = 'platform_admin',
  platform_support = 'platform_support',
  platform_marketing = 'platform_marketing',
  business_owner = 'business_owner',
  business_manager = 'business_manager',
  business_staff = 'business_staff',
  user = 'user',
}
export enum AdminUserCreateDTORole {
  platform_admin = 'platform_admin',
  platform_support = 'platform_support',
  platform_marketing = 'platform_marketing',
  business_owner = 'business_owner',
  business_manager = 'business_manager',
  business_staff = 'business_staff',
  user = 'user',
}
export enum AdminUserUpdateDTORole {
  platform_admin = 'platform_admin',
  platform_support = 'platform_support',
  platform_marketing = 'platform_marketing',
  business_owner = 'business_owner',
  business_manager = 'business_manager',
  business_staff = 'business_staff',
  user = 'user',
}
export enum BusinessCreateOpeningHourDTODayOfWeek {
  Value0 = 0,
  Value1 = 1,
  Value2 = 2,
  Value3 = 3,
  Value4 = 4,
  Value5 = 5,
  Value6 = 6,
}
export enum BusinessCreateRatingDTOLevel {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  NotAvailable = 'NotAvailable',
}
export enum BusinessReviewFilterCreateDTOLevel {
  High = 'High',
  Medium = 'Medium',
  Low = 'Low',
  NotAvailable = 'NotAvailable',
}
export enum PlanUpdateDTOStatus {
  Value0 = 0,
  Value1 = 1,
}
export enum UserEventEntityType {
  business = 'business',
  plan = 'plan',
  review = 'review',
  user = 'user',
  favorite = 'favorite',
}
export enum UserEventSource {
  mobile = 'mobile',
  admin = 'admin',
  api = 'api',
}
export enum UserEventCreateDTOEventType {
  business_viewed = 'business_viewed',
  business_favorited = 'business_favorited',
  business_unfavorited = 'business_unfavorited',
  business_created = 'business_created',
  plan_created = 'plan_created',
  plan_completed = 'plan_completed',
  plan_deleted = 'plan_deleted',
  review_submitted = 'review_submitted',
  user_registered = 'user_registered',
  filter_selected = 'filter_selected',
  category_selected = 'category_selected',
  search_performed = 'search_performed',
  admin_business_viewed = 'admin_business_viewed',
  admin_business_updated = 'admin_business_updated',
  admin_business_status_changed = 'admin_business_status_changed',
  admin_business_deleted = 'admin_business_deleted',
  admin_user_viewed = 'admin_user_viewed',
  admin_user_updated = 'admin_user_updated',
  admin_user_status_changed = 'admin_user_status_changed',
  admin_user_deleted = 'admin_user_deleted',
  admin_user_role_changed = 'admin_user_role_changed',
  admin_review_visibility_changed = 'admin_review_visibility_changed',
}
export enum UserEventCreateDTOEntityType {
  business = 'business',
  plan = 'plan',
  review = 'review',
  user = 'user',
  favorite = 'favorite',
}
export enum UserEventCreateDTOSource {
  mobile = 'mobile',
  admin = 'admin',
  api = 'api',
}
